@if (dataVisible$ | async) {
  <form [formGroup]="specRowFormGroup">
    @if (specRowFormGroup.controls.saldoRow.value !== 0) {
      <div class="row">
        <div class="col col-1">
          Inkomsten uit overige werkzaamheden
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="inkomstenUitOVerigeWerkzaamheden"
            id="inkomstenUitOVerigeWerkzaamheden"
            placeholder="0"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
      <div class="row">
        <div class="col col-1">
          Af: Kosten overige werkzaamheden
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="kostenTerZakeVanOverigeWerkzaamheden"
            id="kostenTerZakeVanOverigeWerkzaamheden"
            placeholder="0"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
      <div class="row pb-3">
        <div class="col col-1">
          <b>Saldo overige werkzaamheden</b>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="saldoRow"
            id="saldoRow"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if (specRowFormGroup.controls.saldoTbs.value !== 0) {
      <div class="row">
        <div class="col col-1">
          Inkomsten uit terbeschikkingstelling
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="inkomstenUitTBS"
            id="inkomstenUitTBS"
            placeholder="0"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row">
        <div class="col col-1">
          Af: Kosten terbeschikkingstelling
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="kostenTerZakeVanTBS"
            id="kostenTerZakeVanTBS"
            placeholder="0"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row">
        <div class="col col-1">
          Af: Terbeschikkingsstellingsvrijstelling
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="tbsVrijstelling"
            id="tbsVrijstelling"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row pb-3">
        <div class="col col-1">
          <b> Saldo terbeschikkingstellingsregeling</b>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="saldoTbs"
            id="saldoTbs"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
  </form>

  <form [formGroup]="specPuFormGroup">
    @if (specPuFormGroup.controls.saldoAlimentatie.value !== 0) {
      <div class="row">
        <div class="col col-1">
          Ontvangen alimentatie
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="ontvangenAlimentatie"
            id="ontvangenAlimentatie"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row">
        <div class="col col-1">
          Af: Kosten ontvangen alimentatie
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="kostenAlimentatie"
            id="kostenAlimentatie"
            placeholder="0"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row pb-3">
        <div class="col col-1">
          <b>Saldo alimentatie</b>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="saldoAlimentatie"
            id="saldoAlimentatie"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if (specPuFormGroup.controls.saldoPerUitkeringen.value !== 0) {
      <div class="row">
        <div class="col col-1">
          Ontvangen periodieke uitkeringen
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="ontvangenPeriodiekeUitkeringen"
            id="ontvangenPeriodiekeUitkeringen"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row">
        <div class="col col-1">
          Af: Kosten periodieke uitkeringen
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="kostenPeriodiekeUitkeringen"
            id="kostenPeriodiekeUitkeringen"
            placeholder="0"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      <div class="row">
        <div class="col col-1">
          <b> Saldo periodieke uitkeringen</b>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="me-1 custom-input-150"
            formControlName="saldoPerUitkeringen"
            id="saldoPerUitkeringen"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
  </form>
  @if (heeftGeenOverigeInkomsten) {
    <p>Er zijn geen overige inkomsten in de aangifte ingevuld.</p>
  }
}

